var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leagueBox",style:(`border-color:${_vm.color};`)},[_c('div',{staticClass:"d-flex leagueItemWrapper"},[_c('span',[_vm._v(_vm._s(_vm.dataSoure?.label)+"：")]),_c('span',[_vm._v(_vm._s(_vm.dataSoure?.count))]),_vm._v("个 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }